import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App.js';
import './index.css';
import { initSentry, Sentry } from './sentry';
import { ThemeProvider } from './theme/ThemeContext';

initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

function Fallback() {
  return (
    <main className="max-w-md mx-auto p-8 mt-12">
      <h1 className="font-display text-3xl mb-3">Что-то сломалось</h1>
      <p className="text-muted mb-4">Мы уже знаем и разбираемся. Попробуйте перезагрузить страницу.</p>
      <button
        onClick={() => window.location.reload()}
        className="inline-flex h-8 items-center rounded bg-accent text-accent-fg px-4 text-sm font-medium hover:opacity-90"
      >
        Перезагрузить
      </button>
    </main>
  );
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      <HelmetProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
